module.exports = __webpack_public_path__ + "img/cooperate_1.ed5fe590.png";